import gql from "graphql-tag";

const PRODUCT_QUERY = gql`  
query Product($productId: String!){
  product(id: $productId) {
        id
        name
        description
        code
        cost
        image{
            original
            thumbnail
            zoom
        }
        maxQty
        stepQty
        startDate
        endDate
        createdAt
        updatedAt
        }
    } 
`;

export default PRODUCT_QUERY;